import styled from 'styled-components'

import { Colors } from '@utils/Colors'

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`

export const TitleWrapper = styled.div`
  margin-bottom: 8px;
  text-align: left;
`

export const VideoWrapper = styled.div`
  position: relative;
  margin-bottom: 16px;
  display: flex;
  justify-content: center;
  aspect-ratio: 16 / 9;
  width: 100%;
`

export const InstructionList = styled.ol`
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const InstructionItem = styled.li`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  font-family: Inter, sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: ${Colors.GRAY500};
`

export const StepNumber = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 24px;
  min-height: 24px;
  background-color: ${Colors.GRAY500};
  color: ${Colors.WHITE};
  font-weight: 700;
  font-size: 12px;
  border-radius: 50%;
`
